import { useEffect, useRef } from 'react'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { fetchAllOperatories } from '@store/actions/operatory.action'

/**
 * Custom hook that automatically fetches operatories when clinic changes
 * Use this in components that need clinic-filtered operatories
 */
export const useClinicOperatories = (): void => {
  const dispatch = useAppDispatch()
  const selectedClinic = useAppSelector((state) => state.clinic.selectedClinic)
  const lastFetchedClinicId = useRef<string | null>(null)

  useEffect(() => {
    if (selectedClinic) {
      const clinicId = selectedClinic.clinic_id
      if (lastFetchedClinicId.current !== clinicId) {
        lastFetchedClinicId.current = clinicId
        dispatch(fetchAllOperatories())
      }
    } else {
      lastFetchedClinicId.current = null
    }
  }, [selectedClinic, dispatch])
}
